import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/wcHh2BmWRaBUUUmeJEKnuN/Mockup_(1x1)_-_OFN5_(Epilepsia).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-66" data-mp="4m8l89fgoljc">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-67" data-mp="12a0j75mcfqrz" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-68" data-mp="x9uqrn89208u">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-69" data-mp="x8b6zmndx72b">
          🌿 BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-5xl font-display text-[21px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-70" data-mp="381xn73sg3cct">
          Ordená la información sobre la epilepsia de tu hijo en 14 días,{' '}
          <span className="text-brand-light" data-id="element-71" data-mp="3e9607lvoxtee">
            sin saturarte.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-72" data-mp="30hhp9lx6haz0">
          <img src={mockupUrl} alt="Mockup del Sistema Información Bajo Control" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-73" data-mp="2qhqtlgwvspxc" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl" data-id="element-74" data-mp="s21iabtr0dzz">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-75" data-mp="id9u8ert6duc">
            SISTEMA INFORMACIÓN BAJO CONTROL™
          </p>
          <p className="-mb-4 mt-3 text-[13px] text-slate-200 sm:text-base" style={{
          fontSize: "14px"
        }} data-id="element-76" data-mp="1b0njrrt6g74f">
            Tu protocolo de gestión de información para madres argentinas que acompañan a sus hijos
            con epilepsia refractaria.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-77" data-mp="110wo3msvrm2r">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="x3h1rzga2cg9">
              <FileTextIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-79" data-mp="3hrlkwjixk99i" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-80" data-mp="1xaceczu3ndrn">
              <ZapIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-81" data-mp="21bfy3xf9pty5" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-82" data-mp="2b0zduu7op7os">
          <ActionButton href="#pricing" showTrust data-id="element-83" data-mp="2l101gscl69ys">
            🧠 QUIERO MI SISTEMA AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}